"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_redux_1 = require("react-redux");
const mui_1 = require("tss-react/mui");
const Typography_1 = __importDefault(require("@mui/material/Typography"));
const Dialog_1 = __importDefault(require("@mui/material/Dialog"));
const DialogTitle_1 = __importDefault(require("@mui/material/DialogTitle"));
const DialogContent_1 = __importDefault(require("@mui/material/DialogContent"));
const IconButton_1 = __importDefault(require("@mui/material/IconButton"));
const Close_1 = __importDefault(require("@mui/icons-material/Close"));
const rootUiActions_1 = require("companion-app-components/flux/root-ui/rootUiActions");
const dataset_shares_1 = require("companion-app-components/flux/dataset-shares");
const profile_1 = require("companion-app-components/flux/profile");
const entitlementsUtils_1 = require("companion-app-components/flux/entitlements/entitlementsUtils");
const utils_1 = require("containers/App/Header/ProfileMenu/utils");
const UserList_1 = __importDefault(require("./components/UserList"));
const actions_1 = require("./actions");
const styles_1 = require("./styles");
const useStyles = (0, mui_1.makeStyles)()(styles_1.styles);
const ManageMembers = ({ dataset }) => {
    var _a;
    const dispatch = (0, react_redux_1.useDispatch)();
    const { classes } = useStyles();
    const profile = (0, react_redux_1.useSelector)((state) => profile_1.profileSelectors.getProfile(state));
    const sharedWith = (_a = (0, react_redux_1.useSelector)((state) => dataset_shares_1.datasetSharesSelectors.getSharesByDatasetId(state, dataset === null || dataset === void 0 ? void 0 : dataset.id))) === null || _a === void 0 ? void 0 : _a.toList();
    const canManageSharePermissions = (0, entitlementsUtils_1.hasCFOEntitlementForDataset)(dataset === null || dataset === void 0 ? void 0 : dataset.entitlements);
    const handleClose = () => {
        dispatch((0, rootUiActions_1.removeDialog)(actions_1.DIALOG_TYPE_MANAGE_MEMBERS));
    };
    return (<Dialog_1.default open sx={{
            '& .MuiPaper-root': {
                padding: '0 20px',
                minWidth: 680,
            },
        }}>
      <DialogTitle_1.default className={classes.dialogTitleWrapper}>
        <Typography_1.default variant="h6" className={classes.title}>
          Manage Access
        </Typography_1.default>
        <Typography_1.default variant="body1" className={classes.textTertiary}>
          Manage who has access to this financial data.
        </Typography_1.default>
      </DialogTitle_1.default>
      <IconButton_1.default aria-label="close" onClick={handleClose} className={classes.closeButton}>
        <Close_1.default />
      </IconButton_1.default>
      <DialogContent_1.default dividers className={classes.dialogContent}>
        <UserList_1.default ownerName={(0, utils_1.getFullName)(profile)} ownerEmail={(profile === null || profile === void 0 ? void 0 : profile.username) || ''} datasetName={dataset === null || dataset === void 0 ? void 0 : dataset.name} manager/>
        {sharedWith.map((share) => (<UserList_1.default share={share} datasetName={dataset === null || dataset === void 0 ? void 0 : dataset.name} canManageSharePermissions={canManageSharePermissions}/>))}
      </DialogContent_1.default>
    </Dialog_1.default>);
};
exports.default = ManageMembers;
